import { type UnknownAction, combineReducers } from "redux";

import { LOG_OUT } from "actions/authentication";
import {
  ADD_ORDER_CONFIRMATION_DETAILS,
  PROCEED_TO_CHECKOUT,
  RETURN_TO_MENU,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_WITH_ERROR,
} from "packages/online_ordering/actions/checkout";
import {
  type PaymentState,
  paymentReducer,
} from "packages/online_ordering/reducers/checkout/payment";
import type { OrderResponse } from "types/reducers/checkout_status";

export interface CheckoutState {
  status: CheckoutStatusState;
  payment: PaymentState;
}

export interface CheckoutStatusState {
  isCheckingOut: boolean;
  orderStatus: "pending" | "success" | "error" | "submitting";
  orderStatusError: null | string;
  orderStatusErrorSource: null | string;
  confirmationCode: null | string;
  orderTime: null | string;
  isOrderAhead: boolean;
  orderMenuError: boolean;
  orderResponse?: OrderResponse;
}

const initialCheckoutStatus: CheckoutStatusState = {
  isCheckingOut: false,
  orderStatus: "pending",
  orderStatusError: null,
  orderStatusErrorSource: null,
  orderMenuError: false,
  confirmationCode: null,
  orderTime: null,
  isOrderAhead: false,
};

function status(
  state: CheckoutStatusState = initialCheckoutStatus,
  action
): CheckoutStatusState {
  switch (action.type) {
    case UPDATE_ORDER_STATUS:
      return {
        ...state,
        orderStatus: action.status,
      };

    case UPDATE_ORDER_STATUS_WITH_ERROR:
      return {
        ...state,
        orderStatus: "error",
        orderStatusError: action.error,
        orderStatusErrorSource: action.errorSource,
        orderMenuError: action.menuError,
      };

    case ADD_ORDER_CONFIRMATION_DETAILS:
      return {
        ...state,
        confirmationCode: action.orderCompletionDetails.confirmationCode,
        orderTime: action.orderCompletionDetails.orderTime,
        isOrderAhead: action.orderCompletionDetails.isOrderAhead,
        orderResponse: action.orderCompletionDetails.orderResponse,
      };

    case RETURN_TO_MENU: {
      return {
        ...state,
        isCheckingOut: false,
        orderStatusError: initialCheckoutStatus.orderStatusError,
        orderStatusErrorSource: initialCheckoutStatus.orderStatusErrorSource,
        orderMenuError: initialCheckoutStatus.orderMenuError,
      };
    }

    case PROCEED_TO_CHECKOUT: {
      return {
        ...state,
        isCheckingOut: true,
      };
    }

    case LOG_OUT: {
      return initialCheckoutStatus;
    }

    default:
      return state;
  }
}

export const checkoutReducers = combineReducers({
  status,
  payment: paymentReducer as (
    state: PaymentState | undefined,
    action: UnknownAction
  ) => PaymentState,
});
